import * as models from '@app/models';
import { FormControl, Grid, IconButton, MenuItem, Select } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Icon from './icon.component';

const PageNavigationComponent: React.FunctionComponent<models.IPageNavigationComponentProps> = (props) => {
	const [currentPage, setCurrentPage] = useState(1);
	let totalPages = 1;
	if (props.totalPages) {
		totalPages = props.totalPages;
	}

	useEffect(() => {
		if (props.page) {
			setCurrentPage(props.page);
		}
	}, [props.page]);

	return (
		<Grid item={true}>
			<Grid container={true} alignItems='center'>
				<Grid item={true}>
					<IconButton
						size='small'
						className='ml-1'
						disabled={currentPage === 1}
						onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
							const previousPage = currentPage - 1;
							props.onChangePage(e, previousPage);
						}}
					>
						<Icon name='chevron-left' className=' icon-dimension-square' />
					</IconButton>
				</Grid>
				<Grid item={true}>
					<FormControl size='small'>
						<Select
							className='ml-1'
							value={currentPage}
							disabled={currentPage === 1 && currentPage === totalPages}
							onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
								const value = +e.target.value;
								props.onChangePage(null, value);
							}}
							renderValue={(value: unknown) => value}
							MenuProps={{ classes: { paper: 'paginator-menu-height' } }}
						>
							{Array.from({ length: totalPages }, (_, i) => i + 1).map((x) => (
								<MenuItem key={x} value={x} dense={true}>
									{x}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Grid>
				<Grid item={true}>
					<IconButton
						size='small'
						className='ml-1 mr-1'
						disabled={currentPage === totalPages}
						onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
							const nextPage = currentPage + 1;
							props.onChangePage(e, nextPage);
						}}
					>
						<Icon name='chevron-right' className='icon-dimension-square' />
					</IconButton>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default PageNavigationComponent;



// WEBPACK FOOTER //
// ./src/components/shared/page-navigation.component.tsx